import React from 'react'
import PropTypes from 'prop-types'
import { constants } from 'common/helpers'

import composeDialogModal from 'components/modal/DialogModal/composeDialogModal'

import messages from './messages'


const ServerErrorModal = composeDialogModal({
  name: constants.modals.ServerError,
  title: ({ data }) => (data.title || messages.title),
  content: ({ data }) => data.content,
  propTypes: {
    data: PropTypes.shape({
      title: PropTypes.string,
      content: PropTypes.string,
    }),
  },
})

export default ServerErrorModal
